export const SET_ASSIGNMENT_RESULTS_TYPE = 'SET_ASSIGNMENT_RESULTS_TYPE';

export function setAssignmentResultsType(updatedAssignmentResultType) {
    return (dispatch) => {
        dispatch({
            type: SET_ASSIGNMENT_RESULTS_TYPE,
            payload: updatedAssignmentResultType
        });
    };
}



// WEBPACK FOOTER //
// ./components/assignment-result/assignment-result-actions.js